import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './theme.js';
import { App } from './App.js';

import '@mantine/core/styles.css';
import './index.css';
import './print.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime:   1000 * 60 * 5,   // 5 минут — снапшоты неизменны для одного SHA
            refetchOnWindowFocus: false,  // на мобильном фокус-возвраты частые, не дёргаем
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <MantineProvider theme={theme} defaultColorScheme="dark">
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </MantineProvider>
    </React.StrictMode>,
);
